// extracted by mini-css-extract-plugin
module.exports = {"tooltipIcon":"_e6c1009"};